import React from 'react';
import { NavBarDropdown } from './NavBarDropdown';
import './Navbar.css';

export function AboutPageNavbar() {
  return (
    <div className="page-navbar">
      <div className="navbar-container">
        <div className="navbar-right">
          <NavBarDropdown />
        </div>
      </div>
    </div>
  );
}
